import { ReactNode } from "react";

type SectionProps = {
  title: string;
  children: ReactNode;
  className?: string;
  mainClassName?: string;
};

const Section = ({
  title,
  children,
  className = "text-sm",
  mainClassName = "space-y-2",
}: SectionProps) => (
  <div className={` ${mainClassName}`}>
    <h2 className={`text-[#212121]/70 font-medium ${className}`}>{title}</h2>
    {children}
  </div>
);

export default Section;
